import { useLayoutEffect, useRef, type ReactNode } from "react";
import { useLocation } from "react-router-dom";

export function RouteTransition({ children }: { children: ReactNode }) {
  const location = useLocation();
  const ref = useRef<HTMLDivElement>(null);
  useLayoutEffect(() => {
    const element = ref.current;
    if (!element || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const content = element.querySelector("main") ?? element;
    const animation = content.animate?.(
      [{ opacity: 0, transform: "translateY(4px)" }, { opacity: 1, transform: "translateY(0)" }],
      { duration: 180, easing: "cubic-bezier(0.2, 0, 0, 1)" }
    );
    return () => animation?.cancel();
  }, [location.pathname, location.search]);
  return <div className="route-transition" ref={ref}>{children}</div>;
}
